/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        01/02/2022 10:40
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */export default class t{static attrPopover="data-hc-popover";static attrContent="data-hc-tooltip-content";static attrPlacement="data-hc-tooltip-placement";static attrInteractive="data-hc-tooltip-interactive";static attrBackgroundColor="data-hc-tooltip-background-color";static attrColor="data-hc-tooltip-color";static attrFontSize="data-hc-tooltip-font-size"}